import Forms from '@/components/forms/Forms'
import DFDRepository from '@/shared/http/repositories/pci/dfd'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import PciDicRepository from '@/shared/http/repositories/pci/pcidic'
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import ActionsForm from '@/shared/mixins/actionsForm'
import recordAccessControl from '@/shared/mixins/recordAccessControl'
import roles from '@/shared/utils/roles'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import ItemTreeView from '../components/treeview/ItemTreeView.vue'
import itemMixim from '../mixins/itemMixim'
import AddItems from './additems.vue'

export default {
  name: 'Items',
  mixins: [ActionsForm, CompanyMixin, itemMixim, PermissionMixin, recordAccessControl],
  components: {
    ItemTreeView,
    AddItems,
    Forms
  },
  data () {
    return {
      isEditing: false,
      isAdding: false,
      list: [],
      objList: [],
      orphans: [],
      dfd: [],
      pciDicItem: [],
      serviceAT: [],
      serviceATSelected: null,
      showDictModal: false,
      dictAdd: null,
      roles: roles
    }
  },
  mounted () {
    loading.push()
    DFDRepository.GetAll(this.$store.getters['company/company'].id)
      .then(response => {
        if (response.data.code > 0) {
          this.dfd = response.data.data
        }
      })
      .catch(err => {
        console.log(err)
        toast.error(this.$lang.Common.Alerts.Error)
      })
      .finally(() => loading.close())

    loading.push()
    PciDicRepository.GetAll(this.$store.getters['company/company'].id)
      .then(response => {
        if (response.data.code > 0) {
          const prop = {
            10: 'Valor',
            11: 'NF',
            12: 'Emissão',
            13: 'Recebimento',
            20: 'Valor',
            21: 'Item',
            22: 'Lançamento',
            23: 'Pedido',
            24: 'Descrição'
          }
          this.pciDicItem = []
          response.data.data.forEach(it => {
            it.itens.forEach(fm => {
              const itm = {
                id: fm.id,
                nome: it.nome + ' - ' + prop[fm.propriedade]
              }
              this.pciDicItem.push(itm)
            })
          })
        }
      })
      .catch(err => {
        console.log(err)
        toast.error(this.$lang.Common.Alerts.Error)
      })
      .finally(() => loading.close())
  },
  methods: {
    getList () {
      loading.push()
      return PCIRepository.GetPCIItems(this.company.id)
        .then(response => {
          if (response.data.code === 0) {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
            return
          }

          this.orphans = [...response.data.data.filter(it => !it.itemPaiID)]
          this.list = response.data.data

          const list = response.data.data.map(item => {
            return {
              id: item.id,
              code: item.codigo,
              mirrorCode: item.codigoEspelho,
              name: item.descricao,
              value: item.codigo,
              parentId: item.itemPaiID,
              type: item.tipo,
              order: item.ordem,
              open: false,
              children: item.tipo === 1 ? [] : null,
              contracts: item.contratos
            }
          })

          return list
        })
        .finally(() => loading.close())
    },
    onLoad () {
      this.getList()
        .then(list => {
          const getOpen = (id, oList) => {
            let result = false
            oList.forEach(item => {
              if (id === item.id) result = result || item.open
              if (item.children) result = result || getOpen(id, item.children)
            })
            return result
          }

          list.forEach(item => {
            item.open = getOpen(item.id, this.objList)
          })

          this.objList = this.getHierarchy(list)
        })
        .catch(err => this.onException(err))
    },
    onUpdate (item) {
      this.isEditing = false
      this.onLoad()
      this.ACCheckOut()
    },
    onCreate (father) {
      this.isAdding = false
      this.onLoad()
    },
    onSaveSort (list) {
      const listToSave = list.map(l => {
        return {id: l.id, ordem: l.order}
      })
      loading.push()
      PCIItemRepository.UpdateSort(listToSave)
        .then(response => {
          if (response.data.code > 0) {
            this.$refs.treeview.confirmSaveSorting()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
        .finally(() => loading.close())
    },
    onSelectItem (item) {
      loading.push()
      this.ACCheckIn('pcimodeloitem', item.id)
        .then(response => {
          if (response.block) {
            toast.error(this.$lang.Common.Alerts.BlockedAccess + ' ' + response.name)
            return
          }
          loading.push()
          PCIItemRepository.Find(item.id)
            .then(response => {
              if (response.data.code > 0) {
                this.isEditing = true
                const it = response.data.data
                this.$nextTick(() => {
                  this.$refs.addItems.used = item.contracts.length > 0
                  this.$refs.addItems.form.dfdID.options = this.dfd
                  this.$refs.addItems.form.pciDicItemID.options = this.pciDicItem
                  this.$refs.addItems.form.dfdID.value = it.formula && it.formula.length ? it.formula[0].dfdid : null
                  this.$refs.addItems.form.pciDicItemID.value = it.formulaSmart && it.formulaSmart.length ? it.formulaSmart[0].pciDicItemID : null
                  this.$refs.addItems.form.children.options = this.orphans
                    ? this.orphans.filter(o => o.id !== item.id)
                    : []
                  this.$refs.addItems.onEditForm(it, this.list)
                })
              }
            })
            .catch(err => this.onException(err))
            .finally(() => loading.close())
        })
        .finally(() => loading.close())
    },
    onBack () {
      if (this.isEditing && !this.isAdding) {
        this.ACCheckOut()
      }
      this.isEditing = false
      this.isAdding = false
    },
    onAdd (item) {
      const promisses = [Promise.resolve()]
      loading.push()
      if (item) {
        promisses.push(PCIItemRepository.Find(item.id))
      }

      Promise.all(promisses)
        .then(response => {
          this.isAdding = true

          this.$nextTick(() => {
            if (response.length > 1 && response[1].data.code > 0) {
              const it = response[1].data.data
              this.$refs.addItems.data.pais = it ? it.pais + ` > ${it.descricao}` : ''
              this.$refs.addItems.father = this.$refs.treeview.getItem(it.id)
              this.$refs.addItems.data.ordem = it.children && it.children.length ? Math.max.apply(Math, it.children.map(c => c.ordem)) + 1 : 1
            } else {
              this.$refs.addItems.data.ordem = Math.max.apply(Math, this.objList.map(c => c.order)) + 1
            }

            this.$refs.addItems.form.codigo.value = 0
            this.$refs.addItems.form.mostrarPci.value = true
            this.$refs.addItems.form.qtdDiasRetroativo.value = 0
            this.$refs.addItems.form.bloqueiaRetroativo.value = 0
            this.$refs.addItems.form.origemDatasParalisacao.value = 0
            this.$refs.addItems.form.pciDicItemID.options = this.pciDicItem
            this.$refs.addItems.form.dfdID.options = this.dfd
            this.$refs.addItems.form.children.options = this.orphans
              ? this.orphans.filter(o => !item || o.id !== item.id)
              : []

            this.$refs.addItems.onEditForm(null, this.list)

            // this.$refs.addItems.form.dfdID.options = this.dfd.map(d => {
            //   return {
            //     code: d.id,
            //     label: d.nome
            //   }
            // })
          })
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (deleteItem) {
      if (deleteItem.children && deleteItem.children.length) {
        toast.error(this.$lang.PCI.Items.Alerts.CannotDeleteWithChildren)
        return
      }
      loading.push()
      PCIItemRepository.Delete(deleteItem.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = this.objList.filter(it => it.id !== deleteItem.id)

            const _remove = (it) => {
              if (it.children) {
                if (it.children.some(it => it.id === deleteItem.id)) {
                  it.children = it.children.filter(it => it.id !== deleteItem.id)
                  return
                }

                it.children.forEach((ch, idx) => {
                  _remove(idx, ch)
                })
              }
            }

            this.objList.forEach((it) => {
              if (it.children) {
                if (it.children.some(it => it.id === deleteItem.id)) {
                  it.children = it.children.filter(it => it.id !== deleteItem.id)
                  return
                }

                it.children.forEach((itc) => {
                  _remove(itc)
                })
              }
            })
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/items/items.js